var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.callOutText)?_c('div',{staticClass:"label-plan-tag"},[_vm._v(_vm._s(_vm.callOutText))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }